export enum MatchPageFilters {
	Summary = 'summary',
    Stats = 'stats',
    Lineups = 'lineups',
    Standings = 'standings',
}